const enum Timeout {
    SEARCH_DELAY = 750,
    DATE_SEARCH_DELAY = 2000
}

export default Timeout;
